'use client';

import AppImage from '@/components/ui/AppImage';
import useScrollReveal from '@/hooks/useScrollReveal';

export default function ContactHero() {
  const { ref: heroRef, isVisible: heroVisible } = useScrollReveal<HTMLElement>();

  return (
    <section ref={heroRef} className="relative py-20 sm:py-24 md:py-32 lg:py-40 overflow-hidden bg-gradient-to-br from-brand-teal via-brand-green to-brand-teal">
      {/* Hero Image */}
      <div className="absolute inset-0 z-0">
        <AppImage
          src="https://img.rocket.new/generatedImages/rocket_gen_img_19344eb77-1772256958184.png"
          alt="Urban creative space with street art, industrial elements, and authentic guerilla aesthetic ready for collaboration"
          width={1920}
          height={1080}
          className="w-full h-full object-cover" />
        
        {/* Dark overlay for edge */}
        <div className="absolute inset-0 bg-black/60"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12 text-center z-10">
        <div className={`transition-all duration-1000 ${heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="inline-block mb-4 sm:mb-6">
            <span className="text-4xl sm:text-5xl animate-float">👋</span>
          </div>
          <h1 className="font-headline text-3xl sm:text-4xl md:text-5xl mb-4 sm:mb-6 text-white font-bold">
            Let's Talk
          </h1>
          <div className="space-y-3 sm:space-y-4 font-body text-sm sm:text-base md:text-lg text-white leading-relaxed max-w-3xl mx-auto px-4">
            <p>
              We work best with founders ready to invest in structure.
            </p>
            <p>
              If you're looking for quick fixes or overnight results, we're not the right fit. If you're building something sustainable and need the infrastructure to support it, let's talk.
            </p>
          </div>
        </div>
      </div>
    </section>);

}